import { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { EchoContext } from './index';

const EchoEventListener = ({ channelName, eventName, callback, children }) => {
  const echo = useContext(EchoContext);

  useEffect(() => {
    if (!echo) {
      return () => {};
    }
    const channel = echo.private(channelName).listen(`.${eventName}`, callback);

    return () => {
      channel.stopListening(`.${eventName}`);
      echo.leaveChannel(channelName);
    };
  }, [echo, channelName, eventName, callback]);

  return children;
};

EchoEventListener.propTypes = {
  channelName: PropTypes.string.isRequired,
  eventName: PropTypes.string.isRequired,
  callback: PropTypes.func.isRequired
};

export default EchoEventListener;
